export class Address {
	street: string;
	number: string;
	floor: string;
	apartment: string;
	complement: string;
	locality: string;
	province: string;
	neighborhood: string;
	postalCode: string;
	latitude: string;
	longitude: string;

	clear() {
		this.street = '';
		this.number = '';
		this.floor = '';
		this.apartment = '';
		this.complement = '';
		this.province = '';
		this.locality = '';
		this.neighborhood = '';
		this.postalCode = '';
		this.latitude = '0';
		this.longitude = '0';
	}
}
